module.exports = ".row.sha-tit-p {\n\tmargin-bottom: 30px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/datas/data-form.component.css
// module id = 1718
// module chunks = 0